import React from 'react'

type SpinnerProps = {
  id?: string
  className?: string
  type?: 'primary' | 'danger'
  size?: number
  speed?: number // in seconds
  'aria-label'?: string
}

const Spinner: React.FC<SpinnerProps> = ({
  id,
  className = '',
  type = 'primary',
  size = 40,
  speed = 1,
  'aria-label': ariaLabel = 'Loading...'
}) => {
  // SVG spinner parameters
  const strokeWidth = size * 0.12
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const arcLength = circumference * 0.25
  const dashArray = `${arcLength} ${circumference}`
  // Color selection
  const color = type === 'danger' ? 'var(--tint-red-500)' : 'var(--tint-blue-500)'

  return (
    <svg
      id={id}
      className={`spinner ${className}`}
      width={size}
      height={size}
      style={{ animationDuration: `${speed}s` }}
      aria-label={ariaLabel}
      role="status"
      viewBox={`0 0 ${size} ${size}`}
    >
      {/* Background circle */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={'var(--tint-blue-90)'}
        strokeWidth={strokeWidth}
      />
      {/* Foreground arc */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={dashArray}
        strokeDashoffset={0}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Spinner
